














import Vue from 'vue';
import {Component, Prop, Ref} from 'vue-property-decorator';
import {mixins} from "vue-class-component"
import UniqueIdMixin from "@/design-system/utilities/UniqueIdMixin"

@Component({})
export default class JdhFilterStructure extends mixins(UniqueIdMixin) {
    @Prop({type: Boolean, default: false}) dropdown!: boolean
    @Ref() containerEl!: HTMLElement

    handleClick(e: MouseEvent) {
        this.$emit('focus', e)
    }
}
